/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { GIC_LIFECYCLE_EVENTS, GIC_LIFECYCLE_EVENTS_PAYLOADS } from './constants.tsx';
import { PubSubHub } from './pub-sub-hub/index.tsx';
import type { PubSub, Subscriber } from './pub-sub-hub/types.tsx';

const GICLifeCycleEventsService: PubSub<GIC_LIFECYCLE_EVENTS, GIC_LIFECYCLE_EVENTS_PAYLOADS> =
	new PubSubHub<GIC_LIFECYCLE_EVENTS, GIC_LIFECYCLE_EVENTS_PAYLOADS>();

/**
 * Non-hook accessor for the GIC lifecycle events service.
 * Use this in non-React contexts (e.g. sweet-state actions).
 */
export const getGICLifeCycleEvents = (): {
	subscribe: <Event extends GIC_LIFECYCLE_EVENTS>(
		event: Event,
		subscriber: Subscriber<GIC_LIFECYCLE_EVENTS_PAYLOADS[Event]>,
	) => () => void;
	unsubscribe: <Event extends GIC_LIFECYCLE_EVENTS>(
		event: Event,
		subscriber: Subscriber<GIC_LIFECYCLE_EVENTS_PAYLOADS[Event]>,
	) => void;
	publish: <Event extends GIC_LIFECYCLE_EVENTS>(
		event: Event,
		payload: GIC_LIFECYCLE_EVENTS_PAYLOADS[Event],
	) => void;
	clearAll: () => void;
} => ({
	...GICLifeCycleEventsService,
});

export const useGICLifeCycleEvents = (): {
	subscribe: <Event extends GIC_LIFECYCLE_EVENTS>(
		event: Event,
		subscriber: Subscriber<GIC_LIFECYCLE_EVENTS_PAYLOADS[Event]>,
	) => () => void;
	unsubscribe: <Event extends GIC_LIFECYCLE_EVENTS>(
		event: Event,
		subscriber: Subscriber<GIC_LIFECYCLE_EVENTS_PAYLOADS[Event]>,
	) => void;
	publish: <Event extends GIC_LIFECYCLE_EVENTS>(
		event: Event,
		payload: GIC_LIFECYCLE_EVENTS_PAYLOADS[Event],
	) => void;
	clearAll: () => void;
} => ({
	...GICLifeCycleEventsService,
});
